import request from './request';
/*
 * 公共接口 V3
 */
export const commonApi = {
  // 短信/邮箱模板
  SMS_TYPE: {

    // TIP 很多场景，用这一个【动态验证码】，即可。
    /**
     * 注册、修改密码、忘记密码…………  等等等等。
     */
    DYNAMIC_VERIFY_CODE: 'DYNAMIC_VERIFY_CODE',

    // // 修改手机号码
    // CHANGE_PHONE_VERIFY: 'CHANGE_PHONE_VERIFY',
    // // 修改登录密码
    // CHANGE_LOGIN_PWD_VERIFY: 'CHANGE_LOGIN_PWD_VERIFY',
    // // 修改交易密码
    // CHANGE_PAY_PWD_VERIFY: 'CHANGE_PAY_PWD_VERIFY',
    // // 用户手机注册验证
    // REGISTER_VERIFY: 'REGISTER_VERIFY',
    // // 用户找回密码验证
    // FORGOT_VERIFY: 'FORGOT_VERIFY',
    // // 用户找回交易密码
    // FORGOT_PAY_PWD_VERIFY: 'FORGOT_PAY_PWD_VERIFY',
    // // 注册成为代理商用户
    // REGISTER_AGENT: 'REGISTER_AGENT',
    // // 线下充值拒绝短信
    // UNDER_LINE_REFUSE: 'UNDER_LINE_REFUSE',
    // // 线下充值成功短信
    // UNDER_LINE_SUCCESS: 'UNDER_LINE_SUCCESS',
    // // 提币申请
    // WITHDRAW_APPLY: 'WITHDRAW_APPLY',
    // // 提币成功
    // WITHDRAW_SUCCESS: 'WITHDRAW_SUCCESS',
    // // 提现申请
    // CASH_WITHDRAWS: 'CASH_WITHDRAWS',
    // // 登录
    // LOGIN: 'LOGIN',
    // // 验证老手机或 邮箱
    // VERIFY_OLD_PHONE: 'VERIFY_OLD_PHONE',
    // // 申请、获取api key
    // API_KEY_GET_VERIFY: 'API_KEY_GET_VERIFY',

  },

  checkMobile (mobile, countryCode) {
    return request({
      url: '/api/u/user/security/check/phoneNo',
      method: 'get',
      params: { mobile, countryCode },
    });
  },
  checkEmail (email) {
    return request({
      url: '/api/u/user/security/check/email',
      method: 'get',
      params: { email },
    });
  },

  // 用户信息
  serverUserinfo (token) {
    return request({
      url: '/v2/u/user/info',
      method: 'get',
      headers: {
        'Authorization': token,
      },
    });
  },

  // 刷新token
  refreshToken (token) {
    if (!token) {
      return;
    }
    return request({
      url: '/v2/u/refreshToken',
      method: 'get',
      headers: {
        'Authorization': token,
      },
    });
  },

  // 改变语言
  changeLanguage (lang) {
    return request({
      url: `/api/u/lang/${lang}`,
    });
  },

  // 获取所有语言
  getLanguage () {
    return request.get('/gw/p/language');
  },

  /**
   * 发送短信/邮箱
   * @param data  需发送的数据
   * @param geetest    极验数据，如果需要则传递不需要则不传递
   */
  sendSms (data, geetest) {
    let _data = {};
    if (data.validateType === 1) { // email
      _data = { email: data.phone, templateCode: data.templateCode };
    } else if (data.validateType === 2) { // phone
      _data = { phoneCode: data.countryCode, templateCode: data.templateCode, mobile: data.phone };
      return request({
        url: '/user/request/bind-phone-otp',
        method: 'post',
        data: _data,
      });
    } else if (data.validateType === 3) { // for register get otp
      _data = { email: data.phone };
      return request({
        url: '/user/request/reg-otp',
        method: 'post',
        data: _data,
      });
    } else if (data.validateType === 4) { // for forgot password get otp
      _data = { email: data.phone };
      return request({
        url: '/user/request/fp-otp',
        method: 'post',
        data: _data,
      });
    }

    if (typeof geetest !== 'undefined') {
      return request({
        url: '/request/otp',
        method: 'post',
        data: _data,
        header: geetest,
      });
    } else {
      return request({
        url: '/request/otp',
        method: 'post',
        data: _data,
      });
    }
  },

  // 获取货币列表 如：cny、usd等法定货币
  getCurrency () {
    // return request.get('/v2/s/exchange/rate');
    return request.get('/gw/w/exchange/rate');
  },

  // 获取货币列表 如：cny、usd等法定货币(c2c交易页面用的多)
  getCurrency2 () {
    return request.get('/v2/s/currency');
  },

  // 获取页面底部数据
  getFooterData () {
    return request.get('/v2/s/support/footer');
  },

  // 提交工单
  addWorkIssue (question, token) {
    return request({
      url: '/v2/s/workIssue/addWorkIssue',
      method: 'post',
      headers: {
        'Authorization': token,
      },
      data: {
        question,
      },
    });
  },

  // 获取工单列表
  getWorkIssueList (current, size, token) {
    return request({
      url: `/v2/s/workIssue/issueList/${current}/${size}`,
      method: 'get',
      headers: {
        'Authorization': token,
      },
    });
  },

  // 获取最新MDP挖矿总量
  getLatestMP () {
    return request.get('https://api3.mbaex.com/counter');
  },
  ipGetCountryCode() {
    return request.get('https://ip-api.com/json');
  },
  getWechatQrCode() {
    return request.get('/app/wechat/qrCode');
  },
  getIpAddress() {
    return request.get('/app/get/region');
  }
};
